import { OrderItemForCartScheme } from '@/apis/rest/generated/types'

export const checkAvailableCartItem = (item: OrderItemForCartScheme) => {
  return (
    item.availableQuantity > 0 && item.isApproved && item.onSale && !item.isRealSoldOut && !item.isDeletedProductOption
  )
}
